import { createElement } from 'react';
import PropTypes from 'prop-types';
import svg from './svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PinChild = function PinChild(_ref) {
  var offset = _ref.offset,
    icon = _ref.icon;
  return /*#__PURE__*/_jsxs("g", {
    transform: "translate(".concat(offset, " ").concat(offset + offset / 4, ")"),
    children: [/*#__PURE__*/_jsx("path", {
      vectorEffect: "non-scaling-stroke",
      d: "M 27,10.999999 C 26.999936,4.924849 22.075087,0 16,0 9.9249129,0 5.0000636,4.924849 5,10.999999 4.9998451,13.460703 6.2398215,15.834434 8.6666665,18.857143 11.093512,21.879851 13.424935,25.819509 16,32 18.614084,25.725879 20.878951,21.8993 23.333333,18.857143 25.787715,15.814985 26.999857,13.488539 27,10.999999 Z"
    }), icon ? /*#__PURE__*/_jsx("g", {
      transform: "translate(9 3.5) scale(0.4375 0.4375)",
      children: icon
    }) : null]
  });
};
PinChild.propTypes = {
  icon: PropTypes.node,
  offset: PropTypes.number
};
var Pin = function Pin(props) {
  return /*#__PURE__*/createElement(svg, props, PinChild);
};
export default Pin;